export default __webpack_public_path__ + "static/media/solution-sewing.f4097935.png";